// This is basically compatibility code since FlexGrid uses gutter nomenclature
// instead of gap.
const getFlexGrids = ({colGap, rowGap}: any) => ({
  colGutter: colGap,
  rowGutter: rowGap,
})

export default getFlexGrids
